/**
 * @author      Pavlo Androshchuk
 * @copyright   Copyright (c) 2022, Zumper
 */

export function pluralize<Word extends string>(
  word: Word,
  count: 1,
  capitalize: true
): `${Capitalize<Word>}`
export function pluralize<Word extends string>(word: Word, count: 1, capitalize?: false): `${Word}`
export function pluralize<Word extends string>(
  word: Word,
  count: number,
  capitalize: true
): `${Capitalize<Word>}` | `${Capitalize<Word>}s`
export function pluralize<Word extends string>(
  word: Word,
  count: number,
  capitalize?: false
): `${Word}` | `${Word}s`
export function pluralize(word: string, count: number, capitalize = false): string {
  const result = count === 1 ? word : `${word}s`

  return capitalize ? capitalizeFirst(result) : result
}

export function pluralizeThereIsAre(count: 1, capitalize: true): 'There is'
export function pluralizeThereIsAre(count: number, capitalize: true): 'There is' | 'There are'
export function pluralizeThereIsAre(count: 1, capitalize?: false): 'there is'
export function pluralizeThereIsAre(count: number, capitalize?: false): 'there is' | 'there are'
export function pluralizeThereIsAre(count: number, capitalize = false) {
  const result = `there ${count === 1 ? 'is' : 'are'}`

  return capitalize ? capitalizeFirst(result) : result
}

const capitalizeFirst = ([first, ...rest]: string) => first.toUpperCase() + rest.join('')
